module.exports = __webpack_public_path__ + "static/media/OM.289c4ffe.svg";